export default {
    topics: [
        {
            title: ' HttpClientRequest ',
            href: 'm-HttpClientRequest-HttpClientRequest.html',
            attributes: { 'data-id': 'm-HttpClientRequest-HttpClientRequest' },
            menu: { hasChildren: false },
            tocID: 'm-HttpClientRequest-HttpClientRequest-d66e5361',
            topics: [],
        },
        {
            title: ' body ',
            href: 'p-HttpClientRequest-body.html',
            attributes: { 'data-id': 'p-HttpClientRequest-body' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-body-d66e5369',
            topics: [],
        },
        {
            title: ' complete ',
            href: 'p-HttpClientRequest-complete.html',
            attributes: { 'data-id': 'p-HttpClientRequest-complete' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-complete-d66e5377',
            topics: [],
        },
        {
            title: ' connect ',
            href: 'm-HttpClientRequest-connect.html',
            attributes: { 'data-id': 'm-HttpClientRequest-connect' },
            menu: { hasChildren: false },
            tocID: 'm-HttpClientRequest-connect-d66e5385',
            topics: [],
        },
        {
            title: ' disconnect ',
            href: 'm-HttpClientRequest-disconnect.html',
            attributes: { 'data-id': 'm-HttpClientRequest-disconnect' },
            menu: { hasChildren: false },
            tocID: 'm-HttpClientRequest-disconnect-d66e5393',
            topics: [],
        },
        {
            title: ' execute ',
            href: 'm-HttpClientRequest-execute.html',
            attributes: { 'data-id': 'm-HttpClientRequest-execute' },
            menu: { hasChildren: false },
            tocID: 'm-HttpClientRequest-execute-d66e5401',
            topics: [],
        },
        {
            title: ' header ',
            href: 'p-HttpClientRequest-header.html',
            attributes: { 'data-id': 'p-HttpClientRequest-header' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-header-d66e5409',
            topics: [],
        },
        {
            title: ' method ',
            href: 'p-HttpClientRequest-method.html',
            attributes: { 'data-id': 'p-HttpClientRequest-method' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-method-d66e5417',
            topics: [],
        },
        {
            title: ' response ',
            href: 'p-HttpClientRequest-response.html',
            attributes: { 'data-id': 'p-HttpClientRequest-response' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-response-d66e5425',
            topics: [],
        },
        {
            title: ' url ',
            href: 'p-HttpClientRequest-url.html',
            attributes: { 'data-id': 'p-HttpClientRequest-url' },
            menu: { hasChildren: false },
            tocID: 'p-HttpClientRequest-url-d66e5433',
            topics: [],
        },
        {
            title: ' wait ',
            href: 'm-HttpClientRequest-wait.html',
            attributes: { 'data-id': 'm-HttpClientRequest-wait' },
            menu: { hasChildren: false },
            tocID: 'm-HttpClientRequest-wait-d66e5442',
            topics: [],
        },
    ],
};

